"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toNoteInteractionRecord = toNoteInteractionRecord;

function toNoteInteractionRecord(interactionRecord, noteContent) {
  var body = noteContent.body,
      plainText = noteContent.plainText;
  var metadata = interactionRecord.metadata.merge({
    body: body,
    plainText: plainText
  });
  return interactionRecord.set('metadata', metadata);
}